import {Pipe, PipeTransform} from '@angular/core';

export const PUBLISHING_FALLBACK = 'Publishing';

/**
 * The in-progress text of a publish process: the stage message the PublishPOItem state machine
 * writes, or the generic text while there is none yet. "in progress" is the placeholder the process
 * record is created with, not a stage, so it falls back too.
 */
@Pipe({
  name: 'publishStatus'
})
export class PublishStatusPipe implements PipeTransform {

  transform(process: { message?: string | null } | null | undefined): string {
    const message = process?.message?.trim();
    if (!message || message.toLowerCase() === 'in progress') {
      return PUBLISHING_FALLBACK;
    }
    return message;
  }
}

/**
 * Short badge text for the stage messages that are too long for a badge in the PO item table. The keys are
 * the exact messages the PublishPOItem state machine writes (content_workflow_cdk_publish_po_stack.py); the
 * other stages ("Preparing delivery", "Collecting files", "Confirming delivery", and the UI's own
 * "Publishing") are already short and are not listed.
 */
export const PUBLISH_STAGE_SHORT_LABELS: Readonly<Record<string, string>> = {
  'packaging files for the destination': 'Packaging',
  'transferring files to the destination': 'Transferring',
  'waiting for the destination to collect the files': 'Waiting',
};

/**
 * The text a badge shows for a publish status (the output of `publishStatus`): the short label of a long
 * stage, otherwise the status itself. Compare the result with the input to know whether the full text
 * should be offered as a tooltip.
 */
@Pipe({
  name: 'publishStageLabel'
})
export class PublishStageLabelPipe implements PipeTransform {

  transform(status: string): string {
    return PUBLISH_STAGE_SHORT_LABELS[status.trim().toLowerCase()] ?? status;
  }
}
